import { useCallback, useEffect, useState } from "react";
import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import { translateISO369 } from "utils/I18nText";
import classes from "./classes.module.scss";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import MediaService from "services/projects/MediaService";
import { container } from "tsyringe";

const mediaService = container.resolve(MediaService);

type IProps = {
	media: MediaResponseResource;
	onOpen: (mediaResponseResource: MediaResponseResource) => void;
};

export default function ImageMediaCard(props: IProps) {
	const [image, setImage] = useState<string | null>(null);

	const handleClick = useCallback(() => {
		props.onOpen(props.media);
	}, [props]);

	useEffect(() => {
		if (!props.media.file) return;
		mediaService.downloadFile(props.media.project.id, props.media.id).then((res) => {
			setImage(URL.createObjectURL(res));
		});
	}, [props]);

	return (
		<div className={classes["root"]}>
			<div onClick={handleClick} className={classes["media-container"]}>
				<LazyImage src={image} alt={props.media.caption ? (translateISO369(props.media.caption) ?? "") : ""} className={classes["media-preview"]} />
			</div>

			{props.media.caption && (
				<Typography type="p" weight="bold" className={classes["title"]}>
					{translateISO369(props.media.caption)}
				</Typography>
			)}
		</div>
	);
}
